export const SERVER_LINK =  "https://api.sayedamin.in";
//export const SERVER_LINK =  "http://localhost:8080";